export const timeConverter = (val) => {
    return val.split('.')[0] + 'Z'
}